import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class BancaServices {

    constructor(private configService: AppConfigService) {}

    getListGame(data = {}, nav: any) {
        data["flag"] = 'BanCaBean_bancaListGames';
        return this.configService.getListGameBanCa(data, nav);
    }

    getBalance(data = {}, nav: any) {
        data["flag"] = 'BanCaBean_bancaCheckUserBalance';
        return this.configService.getBalanceBanCa(data, nav);
    }

    getForwardLink(data = {}, nav: any) {
        data["flag"] = 'BanCaBean_bancaForwardGame';
        return this.configService.getForwardLinkBanCa(data, nav);
    }

    funtransferBanCa(data = {}, nav: any) {
        let flag = data["direction"] === 4 ? "BanCaBean_depositPlayerMoney" : "BanCaBean_withdrawPlayerMoney";
        data["flag"] = flag;
        return this.configService.funtransferBanCa(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/banca.services.ts